import { ITicketActivityState } from "./reducer";

interface IWithTicketActivityState {
  features: {
    ticketActivity: ITicketActivityState;
  };
}

export function selectTicketViewers(state: IWithTicketActivityState, ticketID?: string): string[] {
  return ticketID ? Object.keys(state.features.ticketActivity.viewing[ticketID] || {}).sort() : [];
}

export function selectTicketAgentsTyping(state: IWithTicketActivityState, ticketID: string): string[] {
  return Object.keys(state.features.ticketActivity.typing[ticketID] || {}).sort();
}

export function selectAgentTypingStatus(state: IWithTicketActivityState, ticketID: string, agentID: string): boolean {
  return !!(state.features.ticketActivity.typing[ticketID] || {})[agentID];
}
